document.addEventListener("DOMContentLoaded", function () {
  const tabContents = document.querySelectorAll(".tab-content");
  const tabLinks = document.querySelectorAll(".tabs-nav .nav-button");

  tabContents.forEach((tab) => (tab.style.display = "none"));

  if (tabContents.length > 0) {
    tabContents[0].style.display = "block";
    tabLinks[0].classList.add("active");
  }

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      tabContents.forEach((tab) => (tab.style.display = "none"));
      tabLinks.forEach((btn) => btn.classList.remove("active"));
      const currentTab = document.querySelector(this.getAttribute("href"));
      if (currentTab) {
        currentTab.style.display = "block";
      }
      this.classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tabContents = document.querySelectorAll(".tab-content-simple");
  const tabLinks = document.querySelectorAll(".tabs-nav-simple .nav-button");

  if (tabContents.length === 0 || tabLinks.length === 0) {
    return;
  }

  function resetTabs() {
    tabContents.forEach((tab) => (tab.style.display = "none"));
    tabLinks.forEach((btn) => btn.classList.remove("active"));
  }

  function showTab(tabId) {
    const tabToShow = document.querySelector(`#${tabId}`);
    const tabLink = Array.from(tabLinks).find(
      (link) => link.getAttribute("href") === `#${tabId}`
    );

    if (tabToShow && tabLink) {
      tabToShow.style.display = "block";
      tabLink.classList.add("active");
    }
  }

  function getTabFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab");
  }

  function setTabInUrl(tabId) {
    const params = new URLSearchParams(window.location.search);
    params.set("tab", tabId);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.pushState(null, "", newUrl);
  }

  resetTabs();

  const initialTab = getTabFromUrl() || tabContents[0].id;
  showTab(initialTab);

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const tabId = this.getAttribute("href").substring(1);

      resetTabs();
      showTab(tabId);
      setTabInUrl(tabId);
    });
  });
});
